import { Component, Input, OnInit } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { AttributeModel } from 'src/app/shared/models/attribute.model';
import { AttributesPopupComponent } from '../attributes-popup/attributes-popup.component';

@Component({
    standalone: false,
    selector: 'ziq-attributes-button',
    templateUrl: './attributes-button.component.html',
    styleUrls: ['./attributes-button.component.scss']
})
export class AttributesButtonComponent implements OnInit {
    @Input()
    attributes: AttributeModel;

    @Input()
    description: string;

    constructor(
        private readonly dialog: MatDialog
    ) { }

    ngOnInit(): void { }

    openAttributesPopup(): void {
        if (!this.attributes) {
            return;
        }

        const dialogConfig = new MatDialogConfig();

        dialogConfig.autoFocus = true;
        dialogConfig.data = {
            attributes: this.attributes,
            description: this.description
        };
        dialogConfig.maxHeight = '650px';
        dialogConfig.minWidth = '50%';
        dialogConfig.minWidth = '50%';

        this.dialog.open(AttributesPopupComponent, dialogConfig);
    }

}
